<template>
    <header :style="`background-image: url('${country.headerImage}')`" class="header">
        <v-wrapper>
          <img :alt="country.header3" :src="`${country.headerLogo}`" class="homelogo" />
            <div class="header__caption">
                <h1>{{ country !== null ? country.header1 : '' }}</h1>
                <h1>{{ country !== null ? country.header2 : '' }}</h1>
                <h2>{{ country !== null ? country.header3 : '' }}</h2>
            </div>
            <v-search />
        </v-wrapper>
    </header>
</template>

<script>
import vSearch from './vSearch'
export default {
    components: {
        vSearch
    },
    props: {
        country: {
            type: Object,
            required: false
        }
    }
}
</script>

<style lang="scss">
.header {
    position: relative;
    height: 450px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    &::after {
        content: '';
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: block;
        background-color: rgba(#000000, 0.3);
    }

    .homelogo {
      width: 40%;
      margin: auto;
      margin-bottom: 2rem;
    }

    .wrapper {
        position: relative;
        z-index: 2;
    }

    &__caption {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        h1,
        h2,
        h3 {
            text-shadow: 0 0 8px #000000;
            text-align: center;
        }
        h1 {
            margin-bottom: 0.5rem;
            font-size: 1.8rem;
            color: #ffffff;
        }
        h2 {
            margin-bottom: 2rem;
            font-size: 1.8rem;
            // color: #c9d700;
            color: #ffffff;
            font-weight: 600;
        }
    }
    @media (max-width: 992px) {
        height: auto;
        padding-top: 4rem;
        padding-bottom: 4rem;
        &__caption {
            h1 {
                font-size: 1.6rem;
            }
            h2 {
                font-size: 1.1rem;
            }
            h3 {
                font-size: 1.1rem;
            }
        }
    }
    @media (max-width: 768px) {
        background-image: none !important;
        // background-color: #0129a5;
        background-color: transparent;
        &__caption {
            h1 {
                font-size: 1.2rem;
            }
            h2 {
                margin-bottom: 2rem;
            }
            h3 {
                display: none;
            }
        }
    }
}
</style>
